import script from "./DoughnutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DoughnutChart.vue?vue&type=script&setup=true&lang=js"

import "./DoughnutChart.vue?vue&type=style&index=0&id=6cef8000&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cef8000"]])

export default __exports__